export default {
  text: {
    order_cancelled: 'Bestelling geannuleerd - Geen chauffeur beschikbaar',
    wolt_support: 'Vragen? Bel Wolt rechtstreeks <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENT:</strong> Accepteer of weiger deze bestelling onmiddellijk',
    no_driver_found: '<strong>Geen bezorger gevonden.</strong> Bezorg deze bestelling zelf of annuleer hem',
  },
  labels: {
    dummy_order: 'Testbestelling',
    items_one: '{{count}} artikel',
    items_other: '{{count}} artikelen',
    needs_acceptance: 'Acceptatie vereist',
    driver_pending: 'Wachten op chauffeur',
    driver_search_retrying: 'Nog op zoek naar bezorger',
    no_driver_found: 'Geen bezorger gevonden',
    today: 'Vandaag',
    driver_assigned: 'Chauffeur toegewezen',
    complete: 'Voltooid',
  },
  buttons: {
    complete_order: 'Markeer als voltooid',
    looking_for_driver: 'Op zoek naar een chauffeur...',
    click_to_remove: 'Klik om te verwijderen',
  },
};
